export default __webpack_public_path__ + "static/radio-108cc07883794823ce3dbc97a052ca3c.wav";